var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 218,
    viewBox: "0 0 218 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.544 9.91455H170.377V24.2268H185.544C190 24.2268 193.624 27.8514 193.624 32.3068V47.474H207.937V32.3068C207.937 19.9596 197.892 9.91455 185.544 9.91455ZM24.269 32.3068C24.269 27.8514 27.8937 24.2268 32.349 24.2268H47.5167V9.91455H32.349C20.0018 9.91455 9.95679 19.9596 9.95679 32.3068V47.474H24.269V32.3068ZM193.624 185.502C193.624 189.957 190 193.582 185.544 193.582H170.377V207.894H185.544C197.892 207.894 207.937 197.849 207.937 185.502V170.334H193.624V185.502ZM24.269 185.502V170.334H9.95679V185.502C9.95679 197.849 20.0018 207.894 32.349 207.894H47.5167V193.582H32.349C27.8937 193.582 24.269 189.957 24.269 185.502Z",
    fill: "#AAA8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.781 101.748H17.1132V116.06H200.781V101.748Z",
    fill: "#AAA8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanBig);
export default __webpack_public_path__ + "static/media/scan_big.69ac4054d63c2fba00df7740466b519f.svg";
export { ForwardRef as ReactComponent };